import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { FinalReviewSheetsState } from '@/store/lessons/finalReviewSheet/types';
import mutations from './mutations';
import actions from './actions';
import getters from './getters'

const Lessons: Module<FinalReviewSheetsState, RootState> = {
  state: {
    finalReviewSheets: [],
  },
  mutations,
  actions,
  getters,
};

export default Lessons;
